'use strict';

module Patersons {
    export interface SessionTimeoutModalScope extends ng.IScope {
        currentState: string
        events: Patersons.SessionTimeoutModalCtrl;
    }
    export class SessionTimeoutModalCtrl {

        scope: Patersons.SessionTimeoutModalScope;
        modalInstance: any;
        static $inject = ['$scope', '$uibModalInstance', 'currentState'];

        constructor($scope, $uibModalInstance, currentState) {
            this.scope = $scope;
            this.scope.currentState = currentState;
            this.modalInstance = $uibModalInstance
            this.scope.events = this;
        }

        close(data) {
            this.modalInstance.close(data);
        };
        dismiss(data) {
            this.modalInstance.dismiss(data);
        };
    }
}
